import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledMentionsLink = styled(({ ...props }) => <Link {...props} />)`
    color: inherit;
`;

export default StyledMentionsLink